import { render, staticRenderFns } from "./OperatnEnglishIcon.vue?vue&type=template&id=e8fa8ea8&"
import script from "./OperatnEnglishIcon.vue?vue&type=script&lang=ts&"
export * from "./OperatnEnglishIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports